<template>
  <section class="section">
    <div class="section-body">
      <div class="card" v-if="!isEdit">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>{{ $t("messages.general.searchShowInfo") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChanged"
                      :selectedVal="selLvl"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.classCode")
                      }}<code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                            <div class="form-inline">
                              <div class="input-group-append">
                                <input
                                  type="text"
                                  class="form-control col mr-2"
                                  style="margin-right: 0px !important"
                                  v-model="courseCode"
                                  @keypress="handleSearchClsKey($event)"
                                />
                                <button
                                  type="button"
                                  class="btn btn-temp btn-lg"
                                  @click="handleSearchCls()"
                                >
                                  <i class="fas fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              disabled
                              v-model="courseName"
                            />
                            <button
                              type="button"
                              class="btn btn-danger btn-lg"
                              @click="handleClrCourse()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.section") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select
                        class="form-control"
                        @change="onSelSectionChanged($event)"
                      >
                        <option :selected="selSection == '00'" value="00"
                          >---{{
                            $t("messages.general.notSpecified")
                          }}---</option
                        >
                        <option
                          v-for="(item, index) in sections"
                          :key="index"
                          :value="item.SECTION_TEXT"
                          :selected="selSection == item.SECTION_TEXT"
                        >
                          {{ item.SECTION_TEXT }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group" style="width: 100%">
                <div class="form-inline">
                  <div
                    class="form-group"
                    style="width: 60%; justify-content: center;"
                  >
                    <div class="form-inline">
                      <button
                        type="button"
                        class="btn btn-primary btn-lg"
                        @click="handleSearchConfirmResult()"
                      >
                        {{ $t("messages.general.search") }}</button
                      >&nbsp;&nbsp;&nbsp;
                      <button
                        type="button"
                        class="btn btn-light btn-lg"
                        @click="handleClearScreen()"
                      >
                        {{ $t("messages.general.clearScreen") }}</button
                      >&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                  <div
                    class="form-group"
                    style="width: 40%; justify-content: flex-end;"
                  >
                    <div class="form-inline">
                      <button
                        type="button"
                        class="btn btn-primary btn-lg"
                        @click="cancelRegisByCourseComfirm()"
                        :disabled="this.studentList.length <= 0"
                      >
                        {{ $t("messages.general.cancel") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTable.sortBy"
              :sort-desc.sync="bTable.sortDesc"
              :items="bTable.items"
              :fields="bTable.fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTable.items.length"
                  v-model="currentPage"
                  :per-page="perPage"
                />
                <div
                  v-if="bTable.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPage > 1
                        ? (currentPage - 1) * perPage + 1
                        : currentPage
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPage * perPage > bTable.items.length
                        ? bTable.items.length
                        : currentPage * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTable.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
              </template>
              <template v-slot:head(action)="">
                <label>{{ $t("messages.general.cancel") }}</label
                ><br />
                <input
                  type="checkbox"
                  id="chkDelAll"
                  @change="handleDelChkAll($event)"
                  :checked="
                    bTable.items.length > 0 &&
                      bTable.items.length == studentList.length
                  "
                />
              </template>
              <template v-slot:cell(action)="data">
                <input
                  type="checkbox"
                  id="chkDel"
                  @change="handleDelChk($event, data)"
                  :checked="data.item.selCheck"
                />
              </template>
              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTable.items.length"
                    v-model="currentPage"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTable.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPage > 1
                          ? (currentPage - 1) * perPage + 1
                          : currentPage
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPage * perPage > bTable.items.length
                          ? bTable.items.length
                          : currentPage * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTable.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </div>
      </div>
    </div>
    <v-dialog v-model="dlgCancel" hide-overlay scrollable max-width="30%">
      <v-card tile>
        <v-toolbar flat dense>
          <v-toolbar-title></v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dlgCancel = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 100em;">
                  <label>{{ $t("messages.general.comfirmRegisCourse") }}</label>
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group">
              <div class="form-inline">
                <button
                  class="btn btn-primary btn-lg"
                  type="button"
                  @click="cancelRegisByCourse()"
                >
                  {{ $t("messages.general.ok") }}</button
                >&nbsp;&nbsp;&nbsp;
                <button
                  class="btn btn-light btn-lg"
                  type="button"
                  @click="dlgCancel = false"
                >
                  {{ $t("messages.general.cancel") }}</button
                >&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogSearchProgram"
      hide-overlay
      scrollable
      max-width="80%"
    >
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>search</v-icon>
          <v-toolbar-title>{{
            $t("messages.general.classList")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogSearchProgram = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <!-- <v-card width="100%">
            <v-row>
              <v-col
                class="text-danger"
                style="padding-top: 0; padding-bottom: 0; padding-right: 25px;"
              >
                <p style="margin: 0; text-align: right;">
                  {{ $t("messages.general.programCodeNameReq") }}
                </p>
              </v-col>
            </v-row>
          </v-card> -->
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.classId") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        v-model="dlgCourseCode"
                        type="text"
                        class="form-control col mr-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.className") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        v-model="dlgCourseName"
                        type="text"
                        class="form-control col mr-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.faculty") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultyCourseChanged"
                      :selectedVal="selFacultyCourse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.department") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Department
                      :onChanged="onSelDepartmentCourseChanged"
                      :facultyid="selFacultyCourse"
                      :selectedVal="selDepartmentCourse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    class="btn btn-primary btn-lg"
                    type="button"
                    @click="handleCourseSearch()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-light btn-lg"
                    type="button"
                    @click="cleartCourseProgram()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableProgram.sortBy"
              :sort-desc.sync="bTableProgram.sortDesc"
              :items="bTableProgram.items"
              :fields="bTableProgram.fields"
              :per-page="perPage"
              :current-page="currentPageProgram"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTableProgram.items.length"
                  v-model="currentPageProgram"
                  :per-page="perPage"
                />
                <div
                  v-if="bTableProgram.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPageProgram > 1
                        ? (currentPageProgram - 1) * perPage + 1
                        : currentPageProgram
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPageProgram * perPage > bTableProgram.items.length
                        ? bTableProgram.items.length
                        : currentPageProgram * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableProgram.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTableProgram.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableProgram.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(COURSECODE)="data">
                <a
                  @click="handleSelectCourse(data.item, data.index)"
                  style="text-decoration: underline;"
                >
                  {{ data.item.COURSECODE }}
                </a>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableProgram.items.length"
                    v-model="currentPageProgram"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableProgram.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageProgram > 1
                          ? (currentPageProgram - 1) * perPage + 1
                          : currentPageProgram
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageProgram * perPage >
                          bTableProgram.items.length
                          ? bTableProgram.items.length
                          : currentPageProgram * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableProgram.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmSuccess" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="light-green accent-3">
          <v-icon color="light-green darken-2">fa-check</v-icon>
          <v-toolbar-title style="color: green;"
            >&nbsp;{{
              $t("messages.reqRegister.confirmPopupText")
            }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogConfirmSuccess = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="green accent-1">
          <br />
          <span v-html="successText" style="color: green;">{{
            successText
          }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogError" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="red darken-3">
          <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
          <v-toolbar-title style="color: #ffebee;"
            >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogError = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="red accent-1">
          <br />
          <span style="color: red;" v-html="errorText">{{ errorText }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import AcademicYear from "../components/Dropdown/AcademicYear";
import Semester from "../components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
import Department from "@/components/Dropdown/Department.vue";
import MasterDataProvider from "@/services/masterData_provider";
import EnrollProvider from "@/services/enroll_provider";

const masterDataProvider = new MasterDataProvider();
const enrollProvider = new EnrollProvider();

export default {
  name: "cancelRegisByCourse",
  components: {
    AcademicYear,
    Semester,
    Level,
    Faculty,
    Department,
  },
  data() {
    return {
      dialog: false,
      dlgCancel: false,
      dialogSearchProgram: false,
      dialogSelected: false,
      selYear: 0,
      selSemester: 0,
      selLvl: 0,
      selSection: "00",
      courseId: 0,
      courseCode: "",
      courseName: "",
      sections: [],
      items: [],
      mode: "",
      bTable: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENTCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            tdClass: "text-left text-nowarp",
            thStyle: "width: 250px",
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "COURSENAMEENG",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "SECTION",
            label: this.$t("messages.general.section"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "CREDITATTEMPT",
            label: this.$t("messages.general.credit"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "BALANCE",
            label: this.$t("messages.general.debt"),
            thClass: "align-middle",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "FEE",
            label: this.$t("messages.general.overdueAmout"),
            thClass: "align-middle",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            sortable: true,
          },
        ],
      },
      bTableProgram: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStle: "width: 100px",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "COURSEUNIT",
            label: this.$t("messages.general.credit"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 },
      ],
      perPage: 100,
      perPageStudentReg: 50,
      currentPage: 1,
      currentPageProgram: 1,
      searched: false,
      selected: false,
      selectedIdx: 0,
      isEdit: false,
      isSpecial: false,
      selectedDetail: false,
      dlgCourseCode: "",
      dlgCourseName: "",
      selDepartmentCourse: 0,
      selFacultyCourse: 0,
      extraReg: false,
      extraRegVal: false,
      selectedClsId: 0,
      dialogConfirmSuccess: false,
      successText: "",
      dialogError: false,
      errorText: "",
      dialogErrorTitle: "",
      confirmType: 0,
      totalRequest: 0,
      totalConfirm: "",
      dialogStudents: false,
      currentPageStudentReg: 1,
      studentIdList: [],
      studentList: [],
      tmpStudentList: [],
      tmpStudentIdList: [],
      totalSumSeat: "",
      isEditTotalSumSeat: false,
      dialogRandom: false,
      randomType: "AC",
      totalConfirmDisabled: false,
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.selSection = "00";
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
      this.getSections();
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
      this.getSections();
    },
    onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
    },
    onSelSectionChanged(event) {
      this.selSection = event.target.value;
    },
    onSelFacultyCourseChanged() {
      this.selFacultyCourse = parseInt(event.target.value);
    },
    onSelDepartmentCourseChanged(event) {
      this.selDepartmentCourse = parseInt(event.target.value);
    },
    handleSearchClsKey(event) {
      if (event.charCode == 13) {
        this.handleSearchCls();
      }
    },
    async handleSearchCls() {
      if (this.courseCode != "") {
        this.togglePreLoader(true);
        const result = await enrollProvider.getCourseByAcad({
          token: this.token,
          request: {
            coursecode: this.courseCode,
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            lang: this.currentLang,
          },
        });
        // Fix Dropdown Course List Found Multiple Course
        if (result.code != 500 && result.data.length > 0) {
          if (
            result.data.length == 1 ||
            result.data[0].COURSECODE == this.courseCode
          ) {
            this.handleSelectClass(result.data[0]);
            this.courseList = result;
          } else {
            this.courseList = result;
            this.dlgCourseCode = this.courseCode;
            this.dialogSearchProgram = true;
            this.bTableProgram.items = [];
            if (result.data.length > 0) {
              let idx = 0;
              result.data.map((d) => {
                d.rowNumber = idx + 1;
                this.bTableProgram.items.push(d);
                idx++;
              });
            }
          }
        } else {
          this.dialogError = true;
          this.errorText = result.message;
        }
        this.togglePreLoader(false);
      } else {
        this.handleShowDlgSearchCourse();
      }
    },
    handleClrCourse() {
      this.courseCode = "";
      this.courseName = "";
      this.sections = [];
    },
    async handleSelectClass(item) {
      if (item && item.COURSECODE != null) {
        this.courseId = item.COURSEID;
        this.courseCode = item.COURSECODE;
        this.courseName = item.COURSENAME;
        await this.getSections();
      }
    },
    handleDelChkAll(e) {
      const isChecked = e.target.checked;
      this.bTable.items.map((i) => {
        i.selCheck = isChecked;
        i.action = e.target.checked;
        if (isChecked) {
          this.studentList.push(i.STUDENTCODE);
        }
      });
      if (!isChecked) {
        this.studentList = [];
      }
    },
    handleDelChk(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTable.items[index].selCheck = isChecked;
      if (isChecked) {
        this.studentList.push(item.CLASSID);
      } else {
        const newArr = this.studentList.filter((s) => s != item.STUDENTCODE);
        this.studentList = newArr;
      }
    },
    async getSections() {
      if (this.selYear != 0 && this.selSemester != 0 && this.courseCode != "") {
        this.togglePreLoader(true);
        const data = await masterDataProvider.getSection({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            coursecode: this.courseCode,
            lang: this.currentLang,
          },
        });
        this.sections = data;
        this.togglePreLoader(false);
      }
    },
    async handleSearchConfirmResult() {
      if (this.courseCode != "") {
        this.studentList = [];
        this.togglePreLoader(true);

        //แปลงค่า coursecode จากหน้าจอฟิวรายวิชากรณีไม่ได้กด enter หรือปุ่มแว่นขยาย ให้เป็นค่า courseid เพื่อนำค่าส่งไปยังปุ่มค้นหา
        // if (this.courseCode != "") {
        this.togglePreLoader(true);
        const reg1 = await enrollProvider.getCourseByAcad({
          token: this.token,
          request: {
            coursecode: this.courseCode,
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            lang: this.currentLang,
          },
        });
        // console.log("reg1 handleSearchConfirmResult",reg1);

        if (reg1.code != 500 && reg1.data.length > 0) {
          if (
            reg1.data.length == 1 ||
            reg1.data[0].COURSECODE == this.courseCode
          ) {
            this.handleSelectClass(reg1.data[0]);
          }
        }
        //  }

        const req = {
          acadyear: this.selYear,
          semester: this.selSemester,
          levelid: this.selLvl,
         // courseid: this.courseCode,
          courseid: this.courseId,
          //section: this.selSection == "00" ? "" : this.selSection,
          lang: this.currentLang,
        };
        if (this.selSection == "00") {
          req.section = this.selSection;
        }
        const result = await enrollProvider.getCancelregbycourse({
          token: this.token,
          request: req,
        });
        this.bTable.items = [];
        if (result.length > 0) {
          let idx = 0;
          result.map((d) => {
            d.rowNumber = idx + 1;
            d.selCheck = false;
            this.bTable.items.push(d);
            idx++;
          });
        }
        this.togglePreLoader(false);
      } else {
        this.dialogError = true;
        this.errorText = this.$t("messages.general.programCodeNameReq");
      }
    },
    cancelRegisByCourseComfirm() {
      this.dlgCancel = true;
    },
    async cancelRegisByCourse() {
      this.togglePreLoader(true);
      const resIp = await masterDataProvider.getCurrentIP();
      const temp = {
        token: this.token,
        request: {
          studentidlist: this.bTable.items
            .filter((i) => i.selCheck == true)
            .map((ii) => +ii.STUDENTCODE),
          sequencelist: this.bTable.items
            .filter((i) => i.selCheck == true)
            .map((ii) => +ii.SEQUENCE),
          acadyear: this.selYear,
          semester: this.selSemester,
          classid: this.bTable.items.find((i) => i.selCheck == true).CLASSID,
          courseid: this.bTable.items.find((i) => i.selCheck == true).COURSEID,
          userid: this.mfuUserId,
          ipaddress: resIp.ip, //"127.0.0.1", //
          lang: this.currentLang,
        },
      };
      console.log("temp", temp);
      const result = await enrollProvider.cancelregbycourse(temp);

      if (result.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${result.message}<br/>`;
        this.dlgCancel = false;
        this.handleSearchConfirmResult();
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${result.message}`;
      }
      this.togglePreLoader(false);
    },
    handleClearScreen() {
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvl = 3;
      this.selSection = "00";
      this.handleClrCourse();
      this.selected = false;
      this.searched = false;
      this.selectedIdx = 0;
      this.bTable.items = [];
      this.courseId = 0;
    },
    handleShowDlgSearchCourse() {
      this.cleartCourseProgram();
      this.dialogSearchProgram = true;
    },
    async handleCourseSearch() {
      //if (this.dlgCourseCode != "" || this.dlgCourseName != "") {
      this.togglePreLoader(true);
      const result = await enrollProvider.getCourseByAcad({
        token: this.token,
        request: {
          coursecode: this.dlgCourseCode,
          coursename: this.dlgCourseName,
          facultyid: this.selFacultyCourse,
          departmentid: this.selDepartmentCourse,
          acadyear: this.selYear,
          semester: this.selSemester,
          levelid: this.selLvl,
          lang: this.currentLang,
        },
      });
      this.bTableProgram.items = [];
      if (result.code != 500 && result.data.length > 0) {
        let idx = 0;
        result.data.map((d) => {
          d.rowNumber = idx + 1;
          this.bTableProgram.items.push(d);
          idx++;
        });
      } else {
        this.dialogError = true;
        this.errorText = result.message;
      }
      this.togglePreLoader(false);
      // } else {
      //   this.dialogError = true;
      //   this.errorText = this.$t("messages.general.programCodeNameReq");
      // }
    },
    cleartCourseProgram() {
      this.dlgCourseCode = "";
      this.dlgCourseName = "";
      this.selFacultyCourse = 0;
      this.selDepartmentCourse = 0;
      this.bTableProgram.items = [];
    },
    async handleSelectCourse(item, idx) {
      console.log(idx);
      this.courseId = item.COURSEID;
      this.courseCode = item.COURSECODE;
      this.courseName = item.COURSENAME;
      this.handleSelectClass(item); //ส่งค่า courseid ปุ่มฟ้า
      await this.getSections();
      this.dialogSearchProgram = false;
    },
  },
  watch: {
    currentLang() {
      this.bTableProgram.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStle: "width: 100px",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "COURSEUNIT",
          label: this.$t("messages.general.credit"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      this.bTable.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENTCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          tdClass: "text-left text-nowarp",
          thStyle: "width: 250px",
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "COURSENAMEENG",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "SECTION",
          label: this.$t("messages.general.section"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "CREDITATTEMPT",
          label: this.$t("messages.general.credit"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "BALANCE",
          label: this.$t("messages.general.debt"),
          thClass: "align-middle",
          tdClass: "text-right text-nowarp",
          sortable: true,
        },
        {
          key: "FEE",
          label: this.$t("messages.general.overdueAmout"),
          thClass: "align-middle",
          tdClass: "text-right text-nowarp",
          sortable: true,
        },
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          sortable: true,
        },
      ];
    },
  },
};
</script>
